import React from 'react'

export default function Education(props) {
    return (
        <>
            <h4 className="leftside-line">{props.degreeName}</h4>
            <div>
                <h3>{props.session}</h3>
                <p>{props.universityName}</p>
                <p className="percentage">
                    {(props.percentage.toLowerCase().startsWith("current")) ? <span>current Percentage : {props.percentageMark}% (till {props.tillYear}) <a className="btn" href={props.gradeLink} target="_blank" rel="noopener noreferrer">
  Grade Card
</a></span> : <span className="percentage">Percentage : {props.percentageMark}% {(props.gradeLink)?<a className="btn" href={props.gradeLink} target="_blank" rel="noopener noreferrer">
  Grade Card
</a> : ""}</span>}
                </p>
            </div>
        </>
    )
}
